import React from "react";
import { useTranslation } from "react-i18next";
import "./TermsAndConditions.css";

const TermsAndConditionsOtherContent = (props) => {
  const { t } = useTranslation("common");
  return (
    <>
      <div className="legal-1">{t("modal.description")}</div>
      <div className="modalbox">
        <div className="modalcol1">
          <h4 className="modalheading">
            <b>{t("modal.authusers")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal.authusers1")} </li>
            <li>{t("modal.authusers2")} </li>
            <li>{t("modal.authusers3")} </li>
            <li>{t("modal.authusers4")} </li>
            <li>
              {t("modal.authusers5")}
              <ol className="romanList">
                <li>{t("modal.auth1")}</li>
                <li>{t("modal.auth2")}</li>
                <li>{t("modal.auth3")}</li>
                <li>{t("modal.auth4")}</li>
                <li>{t("modal.auth5")}</li>
                <li>{t("modal.auth6")}</li>
                <li>{t("modal.auth7")}</li>
              </ol>
            </li>
            <li>{t("modal.authusers6")} </li>
            <ol className="romanList">
              <li>{t("modal.auth8")}</li>
              <li>{t("modal.auth9")}</li>
            </ol>
          </ol>

          <h4 className="modalheading">
            <b>{t("modal.regauthusers")}</b>
          </h4>
          <p className="desciption">{t("modal.regauthdesc")}</p>
          <ol className="romanList">
            <li>{t("modal.regauthusers1")} </li>
            <li>{t("modal.regauthusers2")} </li>
            <p className="desciption">{t("modal.regauthdescption")}</p>
          </ol>
          <br />
        </div>

        <div className="modalcol2">
          <h4 className="modalheading">
            <b>{t("modal.passwordusers")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal.passwordusers1")} </li>
            <li>{t("modal.passwordusers2")} </li>
            <li>{t("modal.passwordusers3")} </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal.license")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal.license1")} </li>
            <li>
              {t("modal.license2")}
              <ol className="romanList">
                <li>{t("modal.licenseusers1")} </li>
                <li>{t("modal.licenseusers2")} </li>
                <li>{t("modal.licenseusers3")} </li>
                <li>{t("modal.licenseusers4")} </li>
                <li>{t("modal.licenseusers5")} </li>
              </ol>
            </li>
            <li>{t("modal.license3")} </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal.obligations")}</b>
          </h4>
          <p className="desciption">{t("modal.obligationsdescrp")}</p>
          <h4 className="modalheading">
            <b>{t("modal.terms")}</b>
          </h4>
          <ol className="alphaList">
            <li>
              {t("modal.terms1")}
              <ol className="romanList">
                <li>{t("modal.termsusers1")} </li>
                <li>{t("modal.termsusers2")} </li>
                <li>{t("modal.termsusers3")} </li>
              </ol>
            </li>
            <li>
              {t("modal.terms2")}
              <ol className="romanList">
                <li>{t("modal.termsusers4")} </li>
                <li>{t("modal.termsusers5")} </li>
                <li>{t("modal.termsusers6")} </li>
              </ol>
            </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal.services")}</b>
          </h4>
          <p style={{ paddingLeft: "10px" }} className="desciption">
            {t("modal.servicesdescrp")}
          </p>
          <h4 className="modalheading">
            <b>{t("modal.disclaimer")}</b>
          </h4>
          <p style={{ paddingLeft: "10px" }} className="desciption">
            {t("modal.disclaimerdescrp")}
          </p>
        </div>
      </div>
      <p className="pad-2-b"> </p>
    </>
  );
};
export default TermsAndConditionsOtherContent;
